import type { AssetStatus } from "../api/types";
import { useT } from "../i18n";

const COLORS: Record<AssetStatus, string> = {
  NEW: "bg-blue-600",
  QUEUED: "bg-blue-600",
  PROCESSING: "bg-yellow-600",
  READY: "bg-green-600",
  FAILED: "bg-red-600",
};

export function StatusBadge({ status }: { status: AssetStatus }) {
  const { t } = useT();
  const color = COLORS[status] ?? "bg-gray-600";
  return (
    <span
      className={`px-1.5 py-0.5 rounded text-[10px] font-semibold text-white ${color}`}
      title={`Status: ${status}`}
    >
      {t(`status.${status}`)}
    </span>
  );
}